import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { BaseRequestListComponent } from '../base-request-list/base-request-list.component';
import { CommonGridComponent, GridColumn, GridAction } from '../../../shared/components/common-grid/common-grid.component';
import { RequestManagementService, PaginationInfo } from '../../../shared/services/request-management.service';

@Component({
  selector: 'app-sent',
  standalone: true,
  imports: [CommonModule, TranslateModule, CommonGridComponent],
  templateUrl: './sent.component.html',
  styleUrls: ['./sent.component.scss']
})
export class SentComponent extends BaseRequestListComponent implements OnInit {
  
  /**
   * Define columns for sent grid
   */
  columns: GridColumn[] = [
    { key: 'number', label: 'Request Number', translationKey: 'requests.number' },
    {
      key: 'module',
      label: 'Module',
      translationKey: 'requests.module',
      type: 'custom',
      customRender: (value: any) => this.translate.instant(`workflow_types.${value}`)
    },
    { key: 'createdDate', label: 'Sent Date', translationKey: 'requests.sentDate', type: 'date' },
    { key: 'modifiedDate', label: 'Update Date', translationKey: 'requests.updateDate', type: 'date' },
    {
      key: 'status',
      label: 'Status',
      translationKey: 'requests.status',
      type: 'badge'
    }
  ];

  /**
   * Define actions available for sent requests
   */
  actions: GridAction[] = [
    { 
      id: 'view', 
      label: 'common.view', 
      type: 'view', 
      icon: 'bi-eye'
    }
    //,
    // { 
    //   id: 'track', 
    //   label: 'requests.track', 
    //   type: 'track', 
    //   icon: 'bi-search'
    // },
    // { 
    //   id: 'withdraw', 
    //   label: 'requests.withdraw', 
    //   type: 'withdraw', 
    //   icon: 'bi-arrow-counterclockwise'
    // },
    // { 
    //   id: 'resend', 
    //   label: 'requests.resend', 
    //   type: 'resend', 
    //   icon: 'bi-arrow-repeat'
    // }
  ];

  constructor(private requestService: RequestManagementService, private router: Router, private translate: TranslateService) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Fetch sent requests
   */
  override fetchRequests(pageNumber: number, delegationId?: number): void {
    this.loadingSubject$.next(true);

    const paginationInfo: PaginationInfo = this.buildPaginationInfo(pageNumber);

    this.requestService.getSent(paginationInfo, delegationId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.updateRequests(response);
          this.loadingSubject$.next(false);
        },
        error: (error) => {
          this.handleError(error);
        }
      });
  }

  /**
   * Open the request when its row is clicked
   */
  onRowClick(row: any): void {
    this.viewRequest(row);
  }

  /**
   * Handle action triggered from grid
   */
  onTableAction(event: { action: GridAction; row: any }): void {
    switch (event.action.type) {
      case 'view':
        this.viewRequest(event.row);
        break;
      case 'track':
        this.trackRequest(event.row);
        break;
      case 'withdraw':
        this.withdrawRequest(event.row);
        break;
      case 'resend':
        this.resendRequest(event.row);
        break;
    }
  }

  /**
   * View request details in task viewer (read-only)
   */
  private viewRequest(row: any): void {
    if (row?.id && row?.taskId) {
      this.router.navigate(['/requests/task-view', 1, row.id, row.taskId]);
    } else {
      console.warn('Cannot navigate to task viewer: missing request or task ID', row);
    }
  }

  /**
   * Track request status
   */
  private trackRequest(row: any): void {
    console.log('Track request:', row);
    // Open tracking view
  }

  /**
   * Withdraw request
   */
  private withdrawRequest(row: any): void {
    console.log('Withdraw request:', row);
    // Call API to withdraw request
  }

  /**
   * Resend request
   */
  private resendRequest(row: any): void {
    console.log('Resend request:', row);
    // Call API to resend request
  }
}
